<template>
  <div>
    <Head title="Crear Producto" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-sky-400 hover:text-sky-600" href="/products">Productos</Link>
      <span class="text-sky-400 font-medium">/</span> Crear Producto
    </h1>
    <div class="max-w-7xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <div class="w-full pb-8 pr-6">
            <input-file v-model="form.product_image_path" :error="form.errors.product_image_path" class="lg:w-full"
              type="file" accept="image/*" label="Imagen" />
          </div>
          <text-input v-model="form.code" :error="form.errors.code" class="pb-8 pr-6 w-full lg:w-1/3" label="Código" />
          <select-input v-model="form.family" :error="form.errors.family" class="pb-8 pr-6 w-full lg:w-1/3"
            label="Familia">
            <option v-for="family in families" :key="family.id" :value="family.id">{{ family.description }}</option>
          </select-input>
          <select-input v-model="form.category" :error="form.errors.category" class="pb-8 pr-6 w-full lg:w-1/3"
            label="Categoria">
            <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.description }}
            </option>
          </select-input>
          <text-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full lg:w-full"
            label="Descripción" />
          <h1 class="text-xl  my-2 w-full">Precios</h1>
          <div class="border-solid border-4 border-gray-300 lg:w-full	mb-4 pt-2 mr-6">

            <div class="flex lg:w-full">
              <div class="pb-2 pr-6 w-full lg:w-1/5"></div>
              <div class="pb-2 pr-6 w-full lg:w-1/5">Por Caja</div>
              <div class="pb-2 pr-6 w-full lg:w-1/5">Unitario</div>
              <div class="pb-2 pr-6 w-full lg:w-1/5">Sugerido</div>
              <div class="pb-2 pr-6 w-full lg:w-1/5">Impuesto</div>
            </div>

            <div class="flex lg:w-full" v-for="(priceType, index) in pricesTypes">
              <div class="lg:w-1/5 flex justify-end pr-2">
                <button v-if="index > 0" v-on:click="removePrice(index)"
                  class=" select-none rounded-lg h-10 bg-red-500 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-white"
                  type="button">
                  Quitar
                </button>
              </div>

              <text-input v-model="priceType.price" placeholder="Precio por caja" name="pricesTypes[][price]"
                class="pb-8 pr-6 w-full lg:w-1/5" type="text" />
              <text-input v-model="priceType.unit_price" placeholder="Precio unitario" name="pricesTypes[][unit_price]"
                class="pb-8 pr-6 w-full lg:w-1/5" type="text" />
              <text-input v-model="priceType.suggested_price" placeholder="Precio sugerido"
                name="pricesTypes[][suggested_price]" class="pb-8 pr-6 w-full lg:w-1/5" type="text" />
              <select-input v-model="priceType.taxone" name="pricesTypes[][taxone]" class="pb-8 pr-6 w-full lg:w-1/5">
                <option v-for="tax in taxes" :key="tax.id" :value="tax.id">{{ tax.description }}</option>
              </select-input>
              <div class="flex items-center space-x-2">
                <input 
                  id="checkbox" 
                  v-model="priceType.price_type" 
                  name="pricesTypes[][price_type]" 
                  type="checkbox" 
                  class="form-checkbox h-5 w-5 text-blue-600" 
                  checked="true" 
                />
                <label for="checkbox" class="text-gray-700">Venta por pieza</label>
              </div>
            </div>

            <div class="flex w-full justify-center">
              <button v-on:click="addNewPrice" type="button"
                class="text-white bg-blue-400 hover:bg-blue-800 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-xl px-5 py-2.5 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">+</button>
            </div>
          </div>
          <select-input v-model="form.unit" :error="form.errors.unit" class="pb-8 pr-6 w-full lg:w-1/3"
            label="Unidad de medida">
            <option v-for="unit in units" :key="unit.id" :value="unit.id">{{ unit.code }}</option>
          </select-input>
          <text-input v-model="form.existence" :error="form.errors.existence" class="pb-8 pr-6 w-full lg:w-1/3"
            type="number" label="Existencia" />
          <text-input v-model="form.barcode" :error="form.errors.barcode" class="pb-8 pr-6 w-full lg:w-1/3"
            label="Código de barras" />
          <textarea-input v-model="form.details" :error="form.errors.details" class="pb-8 pr-6 w-full"
            label="Detalles" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-sky" type="submit">Crear Producto</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import InputFile from '@/Shared/InputFile'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    InputFile,
  },
  layout: Layout,
  props: {
    taxes: Object,
    families: Object,
    categories: Object,
    typeUsers: Object,
    units: Object,
    price_types: Array,
  },
  remember: 'form',
  data() {
    return {
      pricesTypes: [{
        price: '',
        unit_price: '',
        suggested_price: '',
        taxone: 3,
        price_type: false,
      }],
      form: this.$inertia.form({
        code: '',
        family: '',
        category: '',
        description: '',
        unit: '',
        existence: '',
        barcode: '',
        details: '',
        product_image_path: null,
        additionalPrices: null
      })
    }
  },
  methods: {
    addNewPrice: function () {
      this.pricesTypes.push({
        price: '',
        unit_price: '',
        suggested_price: '',
        taxone: 3,
        price_type: false,
      })
      //this.apartments.push(Vue.util.extend({}, this.apartment))
    },
    removePrice: function (index) {
      this.pricesTypes.splice(index, 1)
    },
    store() {
      console.log(this.pricesTypes);
      this.appendPricesFieldToForm();
      this.form.post('/products');
      //console.log(this.form)

    },
    appendPricesFieldToForm() {
      this.form.additionalPrices = this.pricesTypes;
    }
  },

}
</script>
